module.exports = __webpack_public_path__ + "static/chandra-958907dbf733b1665dff63f096981136.png";